module.exports = __webpack_public_path__ + "static/1-5ceefe2e96ec506fc9004edca12e37b9.jpeg";